import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { EmployeeTeamDto } from "./employee-team.dto";

export class EmployeeTeamResponse extends GlobalResponseObject{
    data?:EmployeeTeamDto[];
     /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
      constructor(status:boolean, intlCode:number, internalMessage:string, data?: EmployeeTeamDto[]){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
}
}